import { useTranslation } from 'react-i18next';
import { useMediaQuery } from '@mui/material';
import dayjs from 'dayjs';

import DeviceLinkCell from '../Cells/LinkCell/DevicesLinkCall';
import { TrapTableTypeLink } from '../trapTables';

import { HubData } from 'api/traps/Hubs/types';
import { MediaBreakpoints } from 'hooks/Screen/useScreenSize';

interface HubExpandableProps {
  data: HubData;
  slug?: string;
}

const HubsExpandable: React.FC<HubExpandableProps> = ({ data, slug }) => {
  const { t } = useTranslation();
  const mobile = useMediaQuery(MediaBreakpoints.mobile);
  const tablet = useMediaQuery(MediaBreakpoints.tablet);
  const desktop = useMediaQuery(MediaBreakpoints.desktop);

  return (
    <div className="d-flex w-100 flex-column">
      {mobile && (
        <div className="d-flex flex-column my-2">
          <div>
            <span className="me-1 fs-14 fw-bold">{t('TrapTables.InteractiveMap')}</span>
            <div>
              <DeviceLinkCell
                data={data.default_plan ?? null}
                icon="ri-treasure-map-line"
                slug={slug}
                deviceType={TrapTableTypeLink.Hubs}
                device_add_slug={data.slug}
              />
            </div>
          </div>
        </div>
      )}

      {tablet && (
        <div className="d-flex flex-column gap-2 justify-content-center my-2">
          <div>
            <span className="me-1 fs-14 fw-bold">{t('TrapTables.TrapsConnected')}</span> {data.traps_connected}
          </div>
        </div>
      )}

      {desktop && (
        <div className="d-flex flex-column gap-2 justify-content-center">
          <div>
            <span className="me-1 fs-14 fw-bold">{`${t('TrapTables.LastConnection')}: `}</span>
            {data?.last_connect ? dayjs(data.last_connect).format('YYYY-MM-DD') : '-'}
          </div>
        </div>
      )}
    </div>
  );
};

export default HubsExpandable;
